import { render, staticRenderFns } from "./trash-user.html?vue&type=template&id=0f150945&scoped=true&"
import script from "./trash-user.js?vue&type=script&lang=js&"
export * from "./trash-user.js?vue&type=script&lang=js&"
import style0 from "./trash-user.scss?vue&type=style&index=0&id=0f150945&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f150945",
  null
  
)

export default component.exports